import { z } from "zod";
import { create } from "zustand";

const editExpenseSchema = z.object({
  expenseDescription: z.string({ message: "Enter expense description" }),
  expenseAmount: z.number({ message: "Enter amount" }).nonnegative(),
  paidTo: z.string({ message: "Enter vendor" }),
  paymentMethod: z.string({ message: "Enter payment method" }),
  expenseDate: z.coerce.date(),
});

type EditExpenseType = z.infer<typeof editExpenseSchema>;

interface SelectedExpense {
  selectedExpense: EditExpenseType | null;
  setSelectedExpense: (selectedExpense: EditExpenseType | null) => void;
}

interface EditState {
  isEditOpen: boolean;
  setIsEditOpen: (isEditOpen: boolean) => void;
}

interface SelectedMonth {
  selectedMonth: number | undefined;
  setSelectedMonth: (selectedMonth: number | undefined) => void;
}

interface SelectedYear {
  selectedYear: number | undefined;
  setSelectedYear: (selectedYear: number | undefined) => void;
}

interface TempSelectedMonth {
  tempSelectedMonth: number | undefined;
  setTempSelectedMonth: (tempSelectedMonth: number | undefined) => void;
}

interface TempSelectedYear {
  tempSelectYear: number | undefined;
  setTempSelectYear: (tempSelectedYear: number | undefined) => void;
}

export const useSelectedMonth = create<SelectedMonth>()((set) => ({
  selectedMonth: undefined,
  setSelectedMonth: (selectedMonth) => set({ selectedMonth }),
}));

export const useTempSelectedMonth = create<TempSelectedMonth>()((set) => ({
  tempSelectedMonth: undefined,
  setTempSelectedMonth: (tempSelectedMonth) => set({ tempSelectedMonth }),
}));

export const useSelectedYear = create<SelectedYear>()((set) => ({
  selectedYear: undefined,
  setSelectedYear: (selectedYear) => set({ selectedYear }),
}));

export const useTempSelectedYear = create<TempSelectedYear>()((set) => ({
  tempSelectYear: undefined,
  setTempSelectYear: (tempSelectYear) => set({ tempSelectYear }),
}));

export const useEditState = create<EditState>()((set) => ({
  isEditOpen: false,
  setIsEditOpen: (isEditOpen) => set({ isEditOpen }),
}));

export const useSelectedState = create<SelectedExpense>()((set) => ({
  selectedExpense: null,
  setSelectedExpense: (selectedExpense) => set({ selectedExpense }),
}));
